export const roundedOneHundredOnHide = (valueLabelSuffix, series_data) => {
  if (!(valueLabelSuffix === '%' && series_data?.length)) return;
  const totalValueSeries = [];
  const restants = [];
  const maxIndexs = [];
  series_data.forEach((serieData, sidx) => {
    (serieData.data || []).forEach((data, index) => {
      const valueData = data || 0;
      if (maxIndexs[index] === undefined) {
        maxIndexs[index] = sidx;
      }
      const maxValueData = series_data[maxIndexs[index]]?.data[index] || 0;
      if (maxIndexs[index] >= 0 && valueData > maxValueData) {
        maxIndexs[index] = sidx;
      }
      totalValueSeries[index] = (totalValueSeries[index] || 0) + valueData;
    });
  });
  totalValueSeries.forEach((totalValue) => {
    const hiddenValue = Math.trunc((100 - totalValue) / series_data.length) * series_data.length;
    const total = totalValue + hiddenValue;
    const restant = 100 - total;
    restants.push(restant);
  });
  for (let sidx = 0; sidx < series_data.length; sidx += 1) {
    const serieData = series_data[sidx];
    const newData = (serieData.data || []).map((data, index) => {
      const restant = sidx === maxIndexs[index] ? restants[index] : 0;
      const hiddenValue = Math.trunc((100 - (totalValueSeries[index] || 0)) / series_data.length);
      const total = (data || 0) + hiddenValue;
      return total + restant;
    });
    serieData.data = newData;
  }
};

export default roundedOneHundredOnHide;
